import React, { useState } from "react";
import PropTypes from "prop-types";
import IconChevronRight from "../../../../../assets/images/svg/chevron-down.svg";

const Accordion = ({ title, content }) => {
  if ((!title && !content) || !content) {
    return null;
  }
  const [isActive, setIsActive] = useState(true);

  const handleClick = () => {
    setIsActive(!isActive);
  };

  return (
    <div data-testid="accordion-component">
      <div className="tw-flex tw-items-center tw-text-sm tw-p-2 tw-bg-blueGray-200">
        <h6 data-testid="accordion-title" className="tw-font-semibold tw-mb-0">
          {title}
        </h6>
        <span
          className="tw-ml-auto tw-text-xl"
          data-testid="accordion-button"
          onClick={handleClick}
        >
          <IconChevronRight
            className="tw-w-5 tw-h-5 tw-cursor-pointer"
            style={
              isActive
                ? {
                    transform: "rotate(180deg)",
                    transitionDuration: "0.2s",
                    transitionProperty: "transform",
                  }
                : {
                    transform: "rotate(0deg)",
                    transitionDuration: "0.2s",
                    transitionProperty: "transform",
                  }
            }
          />
        </span>
      </div>
      {isActive && (
        <div
          data-testid="accordion-content"
          style={{ borderWidth: "1px" }}
          className="tw-p-2 tw-border-blueGray-200 tw-border-solid tw-rounded-sm"
        >
          {content}
        </div>
      )}
    </div>
  );
};

Accordion.propTypes = {
  title: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  content: PropTypes.element,
};

Accordion.defaultProps = {
  title: null,
  content: null,
};
export default Accordion;
